import { Fragment, useEffect, useState } from "react";
import { Checkbox } from "primereact/checkbox";

const MCQExamQuestion = ({ index, isExpired, input, changeHandler }) => {
    const question = input && input.question;
    const [isAnswer, setIsAnswer] = useState();

    useEffect(() => {
        if (input && input.options && input.options.filter(f => f.isAnswer).length > 0) {
            setIsAnswer(input.options.filter(f => f.isAnswer)[0].id);
        }
    }, [input]);

    return (
        <Fragment>
            <div className="row m-0 pl-3 pr-3">
                <div className="col-12">
                    <hr></hr>
                    <label className="question ps-3  py-2" style={{ color: '#0F75BC' }}>{index + 1}. {question}</label>
                    <hr></hr>
                </div>
            </div>
            {
                input.options &&
                input.options.length > 0 &&
                input.options.map((m, i) => (
                    <div className="row m-0 pl-3 pr-3 py-2" key={i}>
                        <div className="col-12">
                            <div className={`flex align-items-center ps-3 m-2 ${isAnswer === m.id && 'text-success'}`}>
                                <Checkbox
                                    inputId={m.id}
                                    disabled={isExpired}
                                    checked={isAnswer === m.id}
                                    onChange={() => {
                                        setIsAnswer(m.id);
                                        changeHandler(input.id, m.id);
                                    }}
                                />
                                <label htmlFor={m.id} className="m-auto ms-3">{m.option}</label>
                            </div>
                        </div>
                    </div>
                ))}
            <hr className="mx-1" />
        </Fragment>
    );
};

export default MCQExamQuestion;
